// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"4e010d8e","919":"4e010d8e"}[chunkId] + ".chunk.css";
};